import styles from "./styles";
import { useEffect } from "react";
import classNames from "classnames";
import AsosWorldLogo from "../../assets/asos-world-logo.svg";
import Decoration from "../decoration";
import { formatHeaderWords } from "../../helpers/formatHeaderWords";
import { Button } from "@asosteam/asos-web-component-library-button";
import EmailIcon from "../../assets/email.svg";
import { getMyAccountUrl } from "../../helpers/getMyAccountUrl";
import { trackPageEvent } from "../../utilities/trackPageEvent";
import { trackCTAInteraction } from "../../utilities/trackCTAInteraction";
import PropTypes from "prop-types";

const header = "Dropping Soon:";
const description =
  "Collect and connect with ASOS.WORLD, our new rewards experience that gives you exclusive benefits. We want to create the best possible experience for everyone, so we've invited a small group of customers to test it out.";
const info = "Stay tuned for more updates, a world of style is on the way.";

const headerFormatted = formatHeaderWords(header);

const analyticsProps = {
  pageName: "not invited landing page",
  buttonType: "keep me updated",
};

const ComingSoon = ({ assetsUrl }) => {
  useEffect(() => {
    trackPageEvent(analyticsProps);
  }, []);
  return (
    <div className={styles.comingSoonImageContainer}>
      <picture className={styles.comingSoonImage}>
        <source
          srcSet={`${assetsUrl}/dWeb-Connect_SS25_kgg07o`}
          media="(min-width: 480px)"
          width="100%"
        />
        <img
          src={`${assetsUrl}/mWeb-Connect_SS25_cbzo9o`}
          alt="connect"
          width="100%"
        />
      </picture>
      <div>
        <div>
          <div className={styles.asosWorldIcon}>
            <AsosWorldLogo aria-label="ASOS World logo" role="img" />
          </div>
        </div>
        <div className={classNames(styles.comingSoonContainer)}>
          <Decoration
            width="60"
            height="302"
            className="app_desktopAndTablet"
          />
          <Decoration
            width="32"
            height="210"
            x="0"
            y="107"
            className="app_mobileOnly"
          />
          <div className={classNames(styles.header, "app_headerASOSWorld")}>
            <h1
              className="app_textBackground"
              aria-label={"Dropping Soon: ASOS.WORLD"}
            >
              {headerFormatted}
              <Decoration width="32" height="36" />
              <br aria-hidden />
              <Decoration width="15" height="36" />
              <br aria-hidden />
              <span aria-hidden>ASOS.WORLD</span>
            </h1>
          </div>
          <Decoration width="32" height="36" className="app_mobileOnly" />
          <div
            className={classNames(
              "app_leavesden1",
              styles.description,
              "app_textBackground"
            )}
          >
            {description}
            <p>{info}</p>
          </div>
          <div
            className={classNames(styles.buttonContainer, "app_textBackground")}
          >
            <span className={styles.stayUpdated}>
              <Button
                elementOverride="a"
                href={getMyAccountUrl("/my-account/contact-preferences")}
                buttonType="primary-asos-world"
                className={styles.stayUpdatedButton}
                size="default"
                onClick={() => {
                  trackCTAInteraction("loyalty-button-click", analyticsProps);
                }}
              >
                <span className={styles.buttonText}>
                  <EmailIcon /> <h2>Stay Updated</h2>
                </span>
              </Button>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;

ComingSoon.propTypes = {
  assetsUrl: PropTypes.string,
};
